export default __webpack_public_path__ + "static/media/zdobycie_zetonu_nieudane.dffbb4e4.gif";